import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { Gallery } from './components/Gallery';
import { Location } from './components/Location';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/ui/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-brand-silver font-body selection:bg-brand-red selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Features data-id="element-4" />
        <Services data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Gallery data-id="element-7" />
        <Location data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <FloatingWhatsApp data-id="element-10" />
    </div>;
}